import { NOTIFY } from '../actions';

export const Notify = (payload) => {
  return {
    type: NOTIFY,
    payload: payload
  };
};
